export default __webpack_public_path__ + "static/media/Logo.a89af1f2.svg";